import * as braze from '@braze/web-sdk';
import { toast } from '@intigral/shared';
import { EVENT } from '../contexts/MixpanelConstants';
import { isNotificationBlocked } from '../helpers/reminder';
import { __ } from '../translations';

interface useReminderPropsTypes {
    // Linear
    'Channel Number'?: string;
    'Channel Name'?: string;
    'Channel Category': string;
    'Program Name'?: string;
    'PA ID'?: string;
    'Listing ID'?: string;
    'Video Codec'?: string;

    // VOD:
    'VOD Name'?: string;
    'VOD Year'?: string;
    'VOD Rating'?: string;
    'VOD Type'?: string;
    'VOD Genre'?: string;
    'VOD AssetID'?: string;
    GUID?: string;
    'VOD Provider'?: string;
    'VOD Category'?: string;
}

export function reminderCallback(
    mixpanelProps: Partial<useReminderPropsTypes> = {},
    reminderState: any,
    reminderError: any,
    reminderItem: any,
    track: any,
    isComingSoonItem: boolean,
    notifyChannels: string[]
) {
    // Show notification
    if (reminderState === 'set') {
        const notifyChannelsText = notifyChannels.map((channelName) => __(channelName)).join(', ');
        toast(
            __(isComingSoonItem ? 'reminder_set_for_coming_soon' : 'reminder_set', {
                notifyChannels: notifyChannelsText,
            })
        );

        if (isNotificationBlocked()) {
            toast(__('browser_notification_permission'), 'error', {
                buttonText: __('turn_on'),
                onButtonClick: () => {
                    Notification.requestPermission();
                    braze.requestPushPermission();
                },
            });
        }
        if (reminderItem?.isPpv) {
            track(EVENT.PPV.PPV_REMINDER_SET, { ...mixpanelProps });
        } else {
            track(EVENT.REMINDER.SET_SUCCESS, { ...reminderItem, ...mixpanelProps });
        }
    } else if (reminderState === 'unset') {
        toast(__('reminder_unset'));
        if (reminderItem?.isPpv) {
            track(EVENT.PPV.PPV_REMINDER_UN_SET, { ...mixpanelProps });
        } else {
            track(EVENT.REMINDER.UNSET_SUCCESS, { ...reminderItem, ...mixpanelProps });
        }
    } else if (reminderState === 'errorSet' || reminderState === 'errorUnset') {
        toast(__('reminder_error'), 'error');
        if (reminderState === 'errorSet') {
            track(EVENT.REMINDER.SET_FAIL, {
                ...reminderItem,
                ...mixpanelProps,
                error: reminderError,
            });
        } else if (reminderState === 'errorUnset') {
            track(EVENT.REMINDER.UNSET_FAIL, {
                ...reminderItem,
                ...mixpanelProps,
                error: reminderError,
            });
        }
    }
}

export default function useReminderState(
    mixpanelProps: Partial<useReminderPropsTypes> = {},
    reminderState: any,
    reminderError: any,
    reminderItem: any,
    reminderIsLoading: boolean,
    track: any,
    name: string,
    isComingSoonItem: boolean
) {
    // Show notification
    if (reminderState === 'set') {
        toast(__(isComingSoonItem ? 'reminder_set_for_coming_soon' : 'reminder_set'));
        if (isNotificationBlocked()) {
            toast(__('browser_notification_permission'), 'error', {
                buttonText: __('turn_on'),
                onButtonClick: () => {
                    Notification.requestPermission();
                    braze.requestPushPermission();
                },
            });
        }

        track(EVENT.REMINDER.SET_SUCCESS, { ...reminderItem, ...mixpanelProps });
    } else if (reminderState === 'unset') {
        toast(__('reminder_unset'));
        track(EVENT.REMINDER.UNSET_SUCCESS, { ...reminderItem, ...mixpanelProps });
    } else if (reminderState === 'errorSet' || reminderState === 'errorUnset') {
        toast(__('reminder_error'), 'error');
        if (reminderState === 'errorSet') {
            track(EVENT.REMINDER.SET_FAIL, {
                ...reminderItem,
                ...mixpanelProps,
                error: reminderError,
            });
        } else if (reminderState === 'errorUnset') {
            track(EVENT.REMINDER.UNSET_FAIL, {
                ...reminderItem,
                ...mixpanelProps,
                error: reminderError,
            });
        }
    }
}
